import {post} from "../API/cloudFunctions";

//**** GateWay Configuration Content ***********
/*const data_config={
  send_update_interval:Number,
  sensor_types:[],// references to sensor type
  monitors:[],// references to monitors
  devices:[],// references to devices {sensore or gateway or ?? forwarder}
  gateway:''
};
//************** GateWay Content ***************
const data_gateway={
  name:'',
  configuration:'',//reference to GateWayConfig
};

*/
export default class GateWay{
   data={
    name:'',
    configuration:'',//reference to GateWayConfig
    description: '',
    is_gateway:'',
    id:''
  };
  constructor(obj){
    if(obj){
      this.data.name=obj.name;
      this.data.id = obj.id;
      this.data.description=obj.description;
      this.data.is_gateway=obj.is_gateway;
      console.log(this.data);
    }
  }

  addGateWay(){
    let data = {
      data :this.data
    };
    return new Promise((resolve, reject) => {
      post('addGateWay',data).then(success => {
        resolve(success)

      }).catch(error => {
        reject(error)
      })
    })
  }


  static getConfigFile(id){
    let el={
      gateway:id,
    };
    return new Promise((resolve, reject) => {
      post('getGateWayConfigFile',el).then(success => {
        resolve(success)

      }).catch(error => {
        reject(error)
      })
    })
  }


  setGateWayConfigs_SensorTypes(gateway_,obj_){
    let data = {
      data: {
        sensor_types: obj_,
        gateway: gateway_
      }
    }
    return new Promise((resolve, reject) => {
      post('setGateWayConfigs', data).then(success => {
        resolve(success)

      }).catch(error => {
        reject(error)
      })
    })
  }

  static setGateWayConfigFile(gateway_Config,cstm_Tkoken){
    let data = {
        gatewayCFG: gateway_Config,
        token:cstm_Tkoken

    };
    return new Promise((resolve, reject) => {
      post('setGateWayConfigFile', data).then(success => {
        resolve(success)

      }).catch(error => {
        reject(error)
      })
    })
  }

  static getGatways() {
    console.log('getGatway Function')
    //console.log('in DEviceJs user '+user)
    let p = {
      data: {}
    }

    return new Promise((resolve, reject) => {
      post('getGatways').then(success => {
        resolve(success)

      }).catch(error => {
        console.log()
        reject(error)
      })
    })
  }
  static getGatway(id) {
    console.log('getGatway Function')
    //console.log('in DEviceJs user '+user)
    let p = {
      data: {id:id}
    }

    return new Promise((resolve, reject) => {
      post('getGatway').then(success => {
        resolve(success)

      }).catch(error => {
        console.log()
        reject(error)
      })
    })
  }


static pushDeviceToGateway(configid,device){
    console.log('configid',configid);
    console.log('device',device);
 let p = {
   data:{
     configuration:configid,
     device:device,
   }
 };
  return new Promise((resolve ,reject)=>{
    post('pushDeviceToGateway',p).then(success=>{
      resolve(success);
    }).catch(err=>{
      reject(err);
    })
  })
}

}





// WEBPACK FOOTER //
// ./src/Class/GateWay.js